module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABdUExURQAAACBEgaTHFDpgkQB2LAB6LQAkDQCaOQAqDwAxEtDSCpuwiACbOv3fAAIodQkveg+fNuPYBT2rK/faAz9VW1uzJMq6GB+kMrbMD4zAGXebrsa2GczRC57FFWGKoTAiE1wAAAAMdFJOUwD+/v6ZmRL+GyH+/um9zhYAAACnSURBVCjPrVLtDoMgEPNjw815d3AgKqjv/5hTdDo3suyHDSRcmjbXhiQ5D+IehUguVVGtZ7rb+/qDKF7gsuRt2BWyA62hk59WrLxBNF7xwUpm4DHAQyZ3q1oBPEbnckIDoOpV0bQAoAmRcjeSnoa2CYqFQCIkTN1CVLuVoUC9WYVdB7A4m6UWBnkIyMrO61rF/wacM/Y9R7sqpg4jXX21K25RiBP/whO7EhNXoDyyTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/br.png
// module id = 3Iej
// module chunks = 1